module.exports = __webpack_public_path__ + "img/event-banner-sm.333c20e9.jpg";